// @ts-nocheck

import { type StateType } from '../../../states';
import { type BasketState } from '../../../states/basket';
import { type GenericAction } from '../../../types/redux';

import basketAddItem from './basketAddItem';
import basketDelItem from './basketDelItem';

const basketSplitMyMatch = (state: BasketState, action: GenericAction, globalState: StateType) => {
  const { payload } = action;
  const { itemIdToRemove, splitedItems } = payload ?? {};
  const { items: basketItems } = state;
  const { sortBy: itemTs } = basketItems[itemIdToRemove] ?? {};

  const stateAfterItemDeleted = basketDelItem(
    state,
    { payload: { oddId: itemIdToRemove, keepStake: true } },
    globalState,
  );
  let stateAfterItemsAdded = stateAfterItemDeleted;

  for (const {
    oddId: selectionItemOddId,
    outcomeId: selectionItemOutcomeId,
    betId: selectionItemBetId,
    matchId: selectionItemMatchId,
    outcomeIds: selectionItemOutcomeIds,
    isFromMultichoice: selectionItemIsFromMultichoice,
  } of splitedItems ?? []) {
    if (Array.isArray(selectionItemOutcomeIds)) {
      for (const outcomeId of selectionItemOutcomeIds) {
        stateAfterItemsAdded = basketAddItem(
          stateAfterItemsAdded,
          {
            payload: {
              oddId: outcomeId,
              betId: selectionItemBetId,
              matchId: selectionItemMatchId,
              isFromMultichoice: true,
              ts: itemTs,
            },
          },
          globalState,
        );
      }
    } else {
      stateAfterItemsAdded = basketAddItem(
        stateAfterItemsAdded,
        {
          payload: {
            oddId: selectionItemOutcomeId ?? selectionItemOddId,
            betId: selectionItemBetId,
            matchId: selectionItemMatchId,
            isFromMultichoice: selectionItemIsFromMultichoice,
            ts: itemTs,
          },
        },
        globalState,
      );
    }
  }

  return stateAfterItemsAdded;
};

export default basketSplitMyMatch;
